define([
    'text!index2021/component/image-float2021.html',
    // 'common/api',
    'jquery',
    '../common/utils',

    'css!index2021/component/image-float2021.css'

], function(
    tpl,
    // Api,
    $,Utils
){
    return {
        template: tpl,
        data: function(){
            return {

            };
        },
        // 这里是传入的数据
        props: {
            images: {
                type: Array
            },
            imageName: {
                type: String
            }
        },
        methods: {
            init: function () {

            },
            fadeChange: function (index,num) {
                var _this = this;
                if(_this.imageName=='pro') return;
                if(_this.imageName=='pro2') return;
                var couldRun = true;
                if(couldRun) {
                    couldRun = false;
                    if(num===0){
                        $('#'+_this.imageName+index).find('.image-float2021').addClass('hide');
                        $('#'+_this.imageName+index).find('.image-float2021').fadeIn();
                    }else {
                        $('#'+_this.imageName+index).find('.image-float2021').removeClass('hide');
                        $('#'+_this.imageName+index).find('.image-float2021').fadeOut();
                    }
                    // 一秒后将变为可运行
                    setTimeout(function(){
                        couldRun = true;
                    },1000);
                }
            }
        },
        mounted: function(){
            this.init();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2021/component/image-float2021.js
// module id = 123
// module chunks = 1 9